import { LAUNCHER_SLOT_URLS } from '../config.js';

// Timeout y fetch tolerante — si un slot falla, el directorio se renderiza con
// los que respondieron (no es bloqueante).
const DEFAULT_TIMEOUT_MS = 8000;

async function fetchSlot(baseUrl, timeoutMs = DEFAULT_TIMEOUT_MS) {
  const url = `${baseUrl}/api/InfraWellhub/GetDirectorioPublico`;
  const t0 = performance.now();
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), timeoutMs);
  try {
    const res = await fetch(url, { cache: 'no-store', signal: ctrl.signal });
    const latencyMs = Math.round(performance.now() - t0);
    if (!res.ok) {
      return { url, data: [], error: true, status: res.status, latencyMs };
    }
    const data = await res.json();
    return { url, data, error: false, status: res.status, latencyMs };
  } catch (err) {
    const latencyMs = Math.round(performance.now() - t0);
    const aborted = err && err.name === 'AbortError';
    return {
      url,
      data: [],
      error: true,
      status: null,
      latencyMs,
      message: aborted ? `timeout (${timeoutMs} ms)` : (err && err.message ? err.message : String(err))
    };
  } finally {
    clearTimeout(timer);
  }
}

// Fan-out a los 4 slots en paralelo. Devuelve el set agregado de centros más
// el detalle por slot (útil para mostrar warning si algún slot fue parcial).
// El backend ya devuelve cada lista pre-ordenada (homologadas alfabético,
// después en_proceso), así que el merge concatena directo. Cada item viene
// con su `idEmpresa` único PERO `idEmpresa` se reusa entre slots (cada slot
// tiene su propia BD). Para evitar colisiones de key en el DOM usamos un
// uid = `slotIdx_idEmpresa`.
export async function getDirectorioPublico(slotBaseUrls = LAUNCHER_SLOT_URLS) {
  const results = await Promise.all(slotBaseUrls.map((u, idx) => fetchSlot(u).then(r => ({ ...r, slotIdx: idx }))));
  const centros = [];
  for (const r of results) {
    if (!r.data || !Array.isArray(r.data)) continue;
    for (const item of r.data) {
      centros.push({
        ...item,
        uid: `${r.slotIdx}_${item.idEmpresa}`,
        slotIdx: r.slotIdx,
        slotBaseUrl: r.url.replace('/api/InfraWellhub/GetDirectorioPublico', '')
      });
    }
  }
  // Re-orden global post-merge: homologadas primero (alfabético), después
  // en proceso (alfabético). Concatenar 4 sets ordenados NO da uno ordenado.
  centros.sort((a, b) => {
    const aHom = a.estado === 'homologada' ? 0 : 1;
    const bHom = b.estado === 'homologada' ? 0 : 1;
    if (aHom !== bHom) return aHom - bHom;
    return (a.nombre || '').localeCompare(b.nombre || '');
  });
  const failedSlots = results.filter(r => r.error).map(r => ({
    url: r.url,
    message: r.message || (r.status ? `HTTP ${r.status}` : 'error')
  }));
  return { centros, failedSlots, totalSlots: results.length };
}
